import { useMemo } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router';
import { ExpenseList } from '@/components/ExpenseList';
import { normalizeExpenseFilters } from '@/application/expenses';
import { useExpenses } from '@/hooks/useExpenses';

export function ExpensesListRoute() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { expenses, loading } = useExpenses();

  const filters = useMemo(() => normalizeExpenseFilters(searchParams), [searchParams]);

  return (
    <>
      <ExpenseList
        loading={loading}
        expenses={expenses}
        filters={filters}
        onFiltersChange={(nextFilters) => setSearchParams((current) => {
          const next = new URLSearchParams(current);
          Object.entries(nextFilters).forEach(([key, value]) => {
            if (value && value !== 'all') next.set(key, value);
            else next.delete(key);
          });
          return next;
        })}
        onSelectExpense={(expenseId: string) => navigate(`/expenses/${expenseId}`)}
      />
      <Outlet />
    </>
  );
}
